import React from "react";
import Button from "components/CustomButtons/Button.js";
import { Visibility } from "@material-ui/icons";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

export default function ActionRetro({ item }) {
  return (
    <>
      {item ? (
        <div className="actions-right">
          <Link to={"/admin/pools/view/" + item._id}>
            <Button justIcon round simple color="success" className="edit">
              <Visibility />
            </Button>
          </Link>
        </div>
      ) : (
        <div></div>
      )}
    </>
  );
}

ActionRetro.propTypes = {
  item: PropTypes.any,
  onCallNetwork: PropTypes.func,
  refresh: PropTypes.func,
};
